import { consume } from '@lit/context';
import { t } from 'i18next';
import { css, html, LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';

import { iconAngleUp, iconChevron } from '@/components/icons';
import { global, GlobalComponentType } from '@/context';
import {
  ConfigurationContextType,
  GlobalConfigurationContext,
} from '@/context/context.configuration';
import { baseStyles, buttonStyles } from '@/styles';

@customElement('fg-configuration-detail-button')
export class FgConfigurationDetailButton extends LitElement {
  @consume({ context: global.context })
  globalContext!: GlobalComponentType;

  @consume({ context: GlobalConfigurationContext, subscribe: true })
  configurationContext!: ConfigurationContextType;

  render() {
    const { layout } = this.globalContext;
    const { showConfigurationDetails, hideConfigurationDetailsToggle } =
      this.configurationContext;

    if (hideConfigurationDetailsToggle) {
      return nothing;
    }

    return html`
      <button
        class=${classMap({
          'button-link': true,
          active: showConfigurationDetails,
          'icon-first': layout === 'wholesale',
        })}
        @click=${() => this.toggleShowDetails()}
      >
        ${layout === 'retail'
          ? t('actions.details')
          : showConfigurationDetails
            ? t('actions.detailsButton.less')
            : t('actions.detailsButton.more')}
        <span>${layout === 'retail' ? iconAngleUp : iconChevron}</span>
      </button>
    `;
  }

  toggleShowDetails() {
    this.dispatchEvent(new Event('details-toggled', { composed: true }));
  }

  static styles = [
    baseStyles,
    buttonStyles,
    css`
      button {
        gap: 5px;
        align-items: center;
      }

      button,
      button span {
        display: flex;
      }

      button.icon-first {
        flex-direction: row-reverse;
      }

      button:not(.active) span {
        transform: rotate(-180deg);
      }
    `,
  ];
}
